import axios from 'axios'
import { getCookie, removeCookies, setCookie } from 'cookies-next'
import { api, nextAPI } from '../apis/Axios'
import { getErrorMessage, log } from './utils'

// https://affiliatewp.com/docs/rest-api-v1-setup-and-usage/#referrals-rest-endpoints
export const AffiliateWPAPI = {
    // @todo we need to figureout refreral
    setVisit(data) {
        data.action = 'visits'
        return nextAPI.post('/affiliates', data)
    },
    setReferral(data) {
        data.action = 'referrals'
        return nextAPI.post('/affiliates', data)
    },
    // check-existing-referral
}

export const AffiliateWP = {
    expiration: 30, // in days
    IDENTIFIER: 'ref',
    COOKIE_NAME: 'affwp_visit_id',

    init(router) {
        const { query } = router

        if (query[this.IDENTIFIER]) {
            this.setVisitCookie({
                affiliate_id: query[this.IDENTIFIER],
                url: router.asPath,
                referrer: document.referrer,
            })
        }
    },

    affWPSetCookie(value) {
        const existingCookie = this.getCookie()
        if (!existingCookie) {
            setCookie(this.COOKIE_NAME, value, {
                maxAge: 60 * 60 * 24 * Number(this.expiration),
                path: '/',
            })
        }
    },

    getCookie() {
        return getCookie(this.COOKIE_NAME)
    },

    deleteCookie() {
        return removeCookies(this.COOKIE_NAME)
    },

    async setVisitCookie(props) {
        let { affiliate_id } = props
        // if cookie is already set, we don't need to set it again
        // but we still need to register visit
        this.affWPSetCookie(affiliate_id)
        props.ip = await this.getIPData()
        await this.try(AffiliateWPAPI.setVisit(props))
    },

    async getIPData() {
        const { data } = await axios.get('https://api.ipify.org/?format=json')
        return data.ip
    },

    async setReferral({ order_id, customer_id }) {
        const affiliate_id = this.getCookie() || false
        let data = {
            customer_id,
            reference: String(order_id),
            context: 'woocommerce',
            status: 'unpaid',
            description: '',
            ip: await this.getIPData(),
        }
        if (affiliate_id) {
            data.affiliate_id = affiliate_id
        }
        await this.try(AffiliateWPAPI.setReferral(data))
        this.deleteCookie() // so only first order is registered as referral
    },

    getAffiliate(data) {
        return api.post('/olm-plugin/v1/get-affiliate', data)
    },

    getExistingReferrals(data) {
        return api.post('/olm-plugin/v1/check-existing-referral', data)
    },

    async try(promise) {
        try {
            await promise
        } catch (e) {
            log(getErrorMessage(e))
        }
    },
}
